// extracted by mini-css-extract-plugin
export default {"SummaryOfCareCrisis":"SummaryOfCareCrisis_SummaryOfCareCrisis__h+LZG","Button":"SummaryOfCareCrisis_Button__rfcIx"};